// src/utils/validate.js
export const isName = (v) => /^[가-힣]{2,5}$/.test(v);
export const isPhone = (v) => /^010\d{8}$/.test(v.replace(/\D/g, ""));
export const isPassword = (v) =>
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^\w\s]).{8,}$/.test(v);
export const isRRNFront = (v) => /^\d{6}$/.test(v);
export const isRRNBack = (v) => /^\d{7}$/.test(v);
export const isPwd = (v) => /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^\w\s]).{8,}$/.test(v); // 영문+숫자+특수 8자↑